"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.plainToClassWithValidationV2 = exports.validateOrReject = exports.parseValidationResults = exports.plainToClassWithValidation = exports.validateWithThrowAsync = exports.getErrorMessageFromValidation = exports.validateWithThrow = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const http_errors_1 = __importStar(require("http-errors"));
function validateWithThrow(object) {
    const validations = (0, class_validator_1.validateSync)(object, { skipMissingProperties: true });
    const errorMessage = getErrorMessageFromValidation(validations);
    if (errorMessage) {
        throw (0, http_errors_1.default)(400, errorMessage);
    }
    else {
        return;
    }
}
exports.validateWithThrow = validateWithThrow;
function getErrorMessageFromValidation(validations) {
    for (const validation of validations) {
        const errorMessage = validateSingularError(validation);
        if (errorMessage) {
            return errorMessage;
        }
    }
    return null;
}
exports.getErrorMessageFromValidation = getErrorMessageFromValidation;
function validateSingularError(validation) {
    if (!(validation === null || validation === void 0 ? void 0 : validation.children))
        return null;
    const constraints = validation.constraints;
    for (const key in constraints) {
        if (constraints[key]) {
            return constraints[key];
        }
    }
    for (const child of validation.children) {
        const errorMessage = validateSingularError(child);
        if (errorMessage) {
            return errorMessage;
        }
    }
    return null;
}
const validateWithThrowAsync = (object) => __awaiter(void 0, void 0, void 0, function* () {
    const validations = yield (0, class_validator_1.validate)(object);
    const errorMessage = getErrorMessageFromValidation(validations);
    if (errorMessage) {
        throw (0, http_errors_1.default)(400, errorMessage);
    }
});
exports.validateWithThrowAsync = validateWithThrowAsync;
const plainToClassWithValidation = (classConstructor, plain, options) => __awaiter(void 0, void 0, void 0, function* () {
    const classInstance = (0, class_transformer_1.plainToClass)(classConstructor, plain, options);
    yield (0, exports.validateWithThrowAsync)(classInstance);
    return classInstance;
});
exports.plainToClassWithValidation = plainToClassWithValidation;
const getErrorMessagesFromConstraints = (constraints) => constraints ? Object.keys(constraints).map((key) => constraints[key]) : [];
/* eslint-disable-next-line @typescript-eslint/no-use-before-define */
const getErrorMessagesFromChildren = (children) => (children === null || children === void 0 ? void 0 : children.map(parseValidationError).flat()) || [];
const parseValidationError = (validation) => [
    ...getErrorMessagesFromConstraints(validation.constraints),
    ...getErrorMessagesFromChildren(validation.children),
];
const parseValidationResults = (validations) => validations === null || validations === void 0 ? void 0 : validations.map(parseValidationError).flat();
exports.parseValidationResults = parseValidationResults;
/* eslint-disable-next-line @typescript-eslint/ban-types */
const validateOrReject = (object, validatorOptions) => __awaiter(void 0, void 0, void 0, function* () {
    const validations = yield (0, class_validator_1.validate)(object, validatorOptions);
    const errorMessages = (0, exports.parseValidationResults)(validations);
    if (errorMessages.length > 1)
        throw new http_errors_1.BadRequest(`Request failed with the following errors: (${errorMessages.join(', ')})`);
    if (errorMessages.length === 1)
        throw new http_errors_1.BadRequest(errorMessages[0]);
});
exports.validateOrReject = validateOrReject;
/**
 * Converts a plain object to a class instance and validates or throws an error if the object is invalid.
 * Validation decorators in class are read in order of bottom to top.
 */
/* eslint-disable-next-line @typescript-eslint/ban-types */
const plainToClassWithValidationV2 = (classConstructor, plain, { transformOptions, validatorOptions, } = {
    transformOptions: {
        excludeExtraneousValues: true,
        exposeDefaultValues: true,
    },
    validatorOptions: { stopAtFirstError: true, forbidUnknownValues: true },
}) => __awaiter(void 0, void 0, void 0, function* () {
    const classInstance = (0, class_transformer_1.plainToClass)(classConstructor, plain, transformOptions);
    yield (0, exports.validateOrReject)(classInstance, validatorOptions);
    return classInstance;
});
exports.plainToClassWithValidationV2 = plainToClassWithValidationV2;
//# sourceMappingURL=Validation.js.map